<template>
  <div>
    <v-dialog
      v-model="isShowDialog"
      persistent
      :width="matchPanelSize"
      transition="dialog-transition"
    >
      <v-card class="d-flex align-end flex-column">
        <v-card-text>
          <v-row no-gutters class="d-flex justify-center">
            <v-col class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <v-row no-gutters class="d-flex justify-space-around">
                <v-col class="col-4 text-left">
                </v-col>
                <v-col class="col-4 text-center">
                  <h1 class="mt-8">TARIFFS</h1>
                </v-col>
                <v-col class="col-4 text-right">
                  <v-btn :disabled="loading" outlined class="mt-6" @click="hideTariffs" large>
                    <v-icon color="white">
                      mdi-close
                    </v-icon>
                  </v-btn>
                </v-col>
                <v-col class="col-12 mt-8">
                  <v-row no-gutters>
                    <v-col class="col-3">
                      <v-btn
                        :disabled="loading" 
                        depressed outlined large 
                        color="primary"
                        @click="isShowAddTariffs = true"
                      >
                        ADD TARIFF
                      </v-btn>
                    </v-col>
                    <v-col class="col-12 mt-5 d-flex justify-space-around justify-center">
                      <div class="fix-height scroll" v-if="tariffsData.length > 0">
                        <v-data-table
                          disable-pagination
                          hide-default-footer
                          :headers="headersTariffs"
                          :items="tariffsData"
                          class="elevation-1"
                        >
                        <template v-slot:item.actions="{ item }">
                          <v-icon
                            small
                            class="mr-2"
                            @click="editTariff(item)"
                          >
                            mdi-pencil
                          </v-icon>
                          <v-icon
                            small
                            @click="deleteTariff(item)"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <AddTariffs :isShowDialog="isShowAddTariffs" @hideAddTariffs="isShowAddTariffs = false"></AddTariffs>
    <EditTariff :isShowDialog="isShowEditTariffs" @hideEditTariffs="isShowEditTariffs = false"></EditTariff>
    <DeleteTariff :isShowDialog="isShowDeleteTariff" @hideDeleteTariff="isShowDeleteTariff = false"></DeleteTariff>
  </div>
</template>

<script>
  import {mapGetters, mapActions, mapMutations} from 'vuex'
  import AddTariffs from './AddTariffs.vue'
  import EditTariff from './EditTariff.vue'
  import DeleteTariff from './DeleteTariff.vue'
  export default {
    props: ['isShowDialog'],
    name: 'Tariffs',
    components:{
      AddTariffs,
      EditTariff,
      DeleteTariff
    },
    data(){
      return {
        isShowAddTariffs: false,
        isShowEditTariffs: false,
        isShowDeleteTariff: false,
        loading: false,
        headersTariffs: [
          { 
            align: 'center',
            text: 'Tariff Number',
            sortable: false,
            value: 'TariffNumber'
          },
          { 
            align: 'center',
            text: 'Tariff ame',
            sortable: false,
            value: 'TariffName',
          },
          { 
            align: 'center',
            text: 'Provider',
            sortable: false,
            value: 'Providers',
          },
          { 
            align: 'center',
            text: 'Measure type Value',
            sortable: false,
            value: 'MeasureTypeValue',
          },
          { 
            align: 'center',
            text: 'Price',
            sortable: false,
            value: 'Price',
          },
          {
            align: 'center',
            text: 'Actions',
            sortable: false,
            value: 'actions',
          }
        ],
        tariffsData: []
      }
    },
    computed:{
      ...mapGetters(['getSubjectCreationDatas', 'getTariffs']),
      matchPanelSize(){
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return '100%'
          case 'sm': return '80%'
          case 'md': return '70%'
          case 'lg': return '50%'
          case 'xl': return '35%'
        }
      }
    },
    async mounted(){
      await this.generateTariffsTable()
      await this.$root.$on("updateTariffTable", async () => {
        await this.generateTariffsTable()
      })
    },
    methods:{
      ...mapActions(['loadTariffs']),
      hideTariffs(){
        this.$emit('HideTariffs')
      },
      editTariff(item){
        console.log(item)
        this.isShowEditTariffs = true
        this.$root.$emit('editTariff', item)
      },
      deleteTariff(item){
        console.log(item)
        this.isShowDeleteTariff = true
        this.$root.$emit('deleteTariff', item.data.id)
      },
      async generateTariffsTable(){
        this.tariffsData = []
        this.loading = true
        this.$root.$emit('loading', "start")
        await this.loadTariffs(1)
        .then(res => {
          console.log(res)
          res.tariffs.sort((a, b) => a.id - b.id).forEach(tariff => {
            const trueId = `00${tariff.id}`
            this.tariffsData.push({
              TariffNumber: `SPT${trueId.substring(trueId.length-2, trueId.length)}`,
              TariffName: tariff.name,
              Providers: tariff.supplier.title,
              MeasureTypeValue: tariff.measureType.value,
              Price: tariff.description,
              data: tariff
            })
          })
          this.$root.$emit('loading', "end")
          this.loading = false
        })
        .catch(e => {
          console.log(e)
          this.$root.$emit('globalError', e.code)
          this.$root.$emit('loading', "end")
          this.loading = false
        })
        //console.log(this.getSubjectCreationDatas.tariffs)
      }
    }
  }
</script>
<style>
.fix-height{
  height: 350px !important;
  display: inline-block;
  width: 100%;
  overflow-y: auto !important;
}
</style>
